import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SiteSettings = {
  maintenance_mode: boolean;
  maintenance_message: string | null;
  updated_at: string;
};

export const useSiteSettings = () => {
  return useQuery<SiteSettings>({
    queryKey: ["site-settings"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("maintenance_mode,maintenance_message,updated_at")
        .eq("id", 1)
        .maybeSingle();
      if (error) throw error;
      return {
        maintenance_mode: !!data?.maintenance_mode,
        maintenance_message: data?.maintenance_message ?? null,
        updated_at: data?.updated_at ?? new Date().toISOString(),
      };
    },
    // Krótki cache + refetch przy powrocie do okna, żeby admin szybko widział efekt
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 60 * 1000,
    retry: 1,
  });
};
